import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AnalyticsTracker from '../components/AnalyticsTracker';
import { hasMarketingConsent } from '../lib/privacyConsent';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export function MetaPixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    let active = true;
    const initialise = () => {
      if (!hasMarketingConsent()) return;
      import('../lib/metaPixel').then(({ initMetaPixel, trackPageView }) => {
        initMetaPixel().then((ok) => {
          if (active && ok) trackPageView();
        });
      });
    };
    initialise();
    const onConsent = (event) => {
      if (event.detail?.marketing) initialise();
    };
    window.addEventListener('cookieConsentUpdate', onConsent);

    return () => {
      active = false;
      window.removeEventListener('cookieConsentUpdate', onConsent);
    };
  }, [pathname]);

  return null;
}

export default function RouteEffects() {
  return (
    <>
      <ScrollToTop />
      <MetaPixelTracker />
      <AnalyticsTracker />
    </>
  );
}
